var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.82 179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.49,138.52H71.6c-1.19,0-11.72-.23-15.25-8-3.83-8.4,4.07-17.47,6.67-20.45l0-.07,5.48-6.1L31.25,14.72,5.49,12.16A6.1,6.1,0,0,1,6.7,0L36.07,3a6.11,6.11,0,0,1,5,3.71l40.18,96.1a6.09,6.09,0,0,1-1.08,6.42l-8,8.94c-3.74,4.31-4.48,6.56-4.63,7.32a10.41,10.41,0,0,0,4,.88h93.89a6.1,6.1,0,1,1,0,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.64,111.22A6.09,6.09,0,0,1,75,99.07l82.66-8.55,6.14-47.78L45.89,38.81a6.09,6.09,0,0,1,.41-12.18l124.63,4.15a6.1,6.1,0,0,1,5.84,6.87l-7.61,59.21a6.1,6.1,0,0,1-5.42,5.29l-87.46,9A4.68,4.68,0,0,1,75.64,111.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,179a18.28,18.28,0,1,1,18.28-18.27A18.29,18.29,0,0,1,152.47,179Zm0-24.37a6.1,6.1,0,1,0,6.09,6.1A6.1,6.1,0,0,0,152.47,154.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,179a18.28,18.28,0,1,1,18.28-18.27A18.3,18.3,0,0,1,74,179Zm0-24.37a6.1,6.1,0,1,0,6.1,6.1A6.11,6.11,0,0,0,74,154.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.158c1c88fb3368b9766382a24b503b98.svg";
export { ForwardRef as ReactComponent };